module.exports = __webpack_public_path__ + "static/section-img2-143a5f2c295fd3c20a6998d0d5d6f7df.png";